// Store language
const state = {
    language: {
        'lang': '',
        'app': null,
        'languages': []
    }
};

const mutations = {
    'SET_LANG' (state, lang) {
        state.language.lang = lang;
    },
    'SET_APP' (state, app) {
        state.language.app = app;
    },
    'SET_LANGUAGES' (state, languages) {
        state.language.languages = languages;
    },
    'CLEAR_APP' (state){
        state.language.app = null;
    }
};

const actions = {
    setLang: ({commit}, lang) => {
        commit('SET_LANG', lang);
    },
    setApp: ({commit}, app) => {
        commit('SET_APP', app);
    },
    setLanguages: ({commit}, languages) => {
        commit('SET_APP', languages);
    },
    clearApp: ({commit}) => {
        commit('CLEAR_APP');
    }
};

const getters = {
    language: state => {
        return state.language;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/language.js